import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './DetailsFilesContainer.css';

class DetailsFilesContainer extends Component {
  static propTypes = {
    header: PropTypes.string,
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: true,
  };

  render() {
    return this.props.show ? (
      <div className="details-files-container">
        <div>{this.props.header}</div>

        {this.props.children}
      </div>
    ) : null;
  }
}

export default DetailsFilesContainer;



// WEBPACK FOOTER //
// ./src/components/shared/details/DetailsFilesContainer.js